import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import relativeTime from 'dayjs/plugin/relativeTime';

export default ({ app: { $dayjs } }) => {
    $dayjs.extend(duration);
    $dayjs.extend(isBetween);
    $dayjs.extend(relativeTime);
};
